import { createFileRoute } from "@tanstack/react-router";

import { CommandMenu, CommandMenuProvider } from "@/components/CommandMenu";
import { LabelDesigner } from "@/features/label-designer/components/LabelDesigner";

export const Route = createFileRoute("/_auth/_app/label-designer")({
  component: () => (
    <CommandMenuProvider>
      <LabelDesigner />
      <CommandMenu />
    </CommandMenuProvider>
  ),
});
